import Prompt from "@/components/Prompt/Prompt";
import { Toaster } from "@/components/ui/sonner";
import { RuntimeProvider } from "@/features/Prompt/RuntimeProvider";
import { ReactNode } from "react";

type AIPromptProps = {
  client: string;
  tools?: ReactNode;
  path_route?: string;
};

export default function AIPrompt({ client, tools, path_route }: AIPromptProps) {
  return (
    <>
      <RuntimeProvider client={client} path_route={path_route}>
        <Prompt tools={tools} />
      </RuntimeProvider>
      <Toaster />
    </>
  );
}
